function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "-45 -45 150 150"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "flat"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9,17H55a2,2,0,0,1,2,2V55a0,0,0,0,1,0,0H7a0,0,0,0,1,0,0V19A2,2,0,0,1,9,17Z",
  style: {
    "fill": "#e8e8e8"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 22,
  y: 21,
  width: 20,
  height: 20,
  style: {
    "fill": "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 55,
  width: 50,
  height: 6,
  style: {
    "fill": "#98a1a1"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,3H49a2,2,0,0,1,2,2v6a0,0,0,0,1,0,0H13a0,0,0,0,1,0,0V5A2,2,0,0,1,15,3Z",
  style: {
    "fill": "#e8e8e8"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 11,
  width: 8,
  height: 6,
  style: {
    "fill": "#98a1a1"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 43,
  y: 11,
  width: 8,
  height: 6,
  style: {
    "fill": "#98a1a1"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 3,
  width: 22,
  height: 4,
  style: {
    "fill": "#98a1a1"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "38 29 34 29 34 25 30 25 30 29 26 29 26 33 30 33 30 37 34 37 34 33 38 33 38 29",
  style: {
    "fill": "#e33e5c"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 17,
  y: 45,
  width: 30,
  height: 6,
  style: {
    "fill": "#98a1a1"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "12 29 10 29 10 20 15 20 15 22 12 22 12 29",
  style: {
    "fill": "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 31,
  width: 2,
  height: 2,
  style: {
    "fill": "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 52,
  y: 58,
  width: 2,
  height: 3,
  style: {
    "fill": "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 58,
  width: 2,
  height: 3,
  style: {
    "fill": "#fff"
  }
})));

export default __webpack_public_path__ + "static/media/medikitBis.5bf383bc.svg";
export { SvgComponent as ReactComponent };